// src/components/ThreeColumnsLayout.jsx
import React from "react";
import ShortDocCol from "./ShortDocCol";
import ProgramsColumn from "./ProgramColumn";
import ImportantLinksColumn from "./ImportantLinkColumn";

const ThreeColumnsLayout = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <ShortDocCol />
        <ProgramsColumn />
        <ImportantLinksColumn />
      </div>
    </div>
  );
};

export default ThreeColumnsLayout;
